import React, { useContext, useEffect } from "react";
import ScreenContext from "../../context/screen/ScreenContext";
import "./NewScreen.css";
import ScreenAuthentication from "../../components/screen-page/ilkb-workout/ScreenAuthentication";
import Spinner from "../../components/layout/Spinner";
import ScreenLinkState from "../../context/screenLink/ScreenLinkState";
import Class from "../../components/screen-page/ilkb-workout/Class";
import ScreenError from "../../components/screen-page/ilkb-workout/ScreenError";
import ClassType from "./ClassType";

const NewScreen = () => {
  const screenContext = useContext(ScreenContext);
  const {
    loading,
    error,
    getScreenByToken,
    screen,
    isScreenAuth,
    setIsScreenAuth,
    updateScreen,
  } = screenContext;

  const getScreenByTokenHandler = () => {
    getScreenByToken();
  };

  useEffect(() => {
    document.title = "ILKB Class Screen";
  }, []);

  useEffect(() => {
    if (!screen) {
      getScreenByTokenHandler();
    }

    if (!localStorage["screen_auth_token"]) {
      setIsScreenAuth(false);
    } else if (!isScreenAuth) {
      setIsScreenAuth(true);
    }

    if (screen && screen.hardRefreshFlag) {
      updateScreen(screen.id, { hardRefreshFlag: false, ...screen }).then(
        () => {
          window.location.reload();
        },
      );
    }
    // eslint-disable-next-line
  }, [loading, error, screen, isScreenAuth]);

  return (
    <ScreenLinkState>
      <div className="main">
        {loading ? (
          <Spinner />
        ) : (
          <>
            {screen && isScreenAuth ? (
              screen.location && screen.location.isEnabled ? (
                <>
                  <ClassType screen={screen} />
                </>
              ) : (
                <ScreenError
                  isScreenAuth={isScreenAuth}
                  checkFunction={getScreenByTokenHandler}
                />
              )
            ) : !isScreenAuth ? (
              <ScreenAuthentication setIsScreenAuth={setIsScreenAuth} />
            ) : (
              <ScreenError
                isScreenAuth={isScreenAuth}
                checkFunction={getScreenByTokenHandler}
              />
            )}
          </>
        )}
      </div>
    </ScreenLinkState>
  );
};

export default NewScreen;
